import { render, staticRenderFns } from "./JobAssignmentOrderAdd.vue?vue&type=template&id=3561a9ea&"
import script from "./JobAssignmentOrderAdd.vue?vue&type=script&lang=js&"
export * from "./JobAssignmentOrderAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports